export default "__VITE_ASSET___7cr0sUm__"